<template>
  <top-stats-container />
</template>

<script>

import TopStatsContainer from '@/components/Widgets/TopStats/TopStatsContainer';

export default {

  name: 'Events',
  components: {
    TopStatsContainer,
  },
  data() {
    return {};
  },
};
</script>

<style lang="css" scoped>
</style>
